export default __webpack_public_path__ + "static/me-dc39acf132570eef02419270af09d4f0.jpg";